import Vue from 'vue'
import Firebase from 'firebase'
import VueFire from 'vuefire'

let config = {
    apiKey: "AIzaSyBrHN9Una6WHBc9rMf7mkGJqN8AC0OmzZo",
    authDomain: "notes-64bc9.firebaseapp.com",
    databaseURL: "https://notes-64bc9.firebaseio.com",
    projectId: "notes-64bc9",
    storageBucket: "notes-64bc9.appspot.com",
    messagingSenderId: "79457707927"
};

let app = Firebase.initializeApp(config);
Vue.use(VueFire);

export default app.database()


// WEBPACK FOOTER //
// ./src/db.js